<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Cafés Théologiques" />
        <CafeTheologique/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import CafeTheologique from './CafeTheologique.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        CafeTheologique,
        FooterComp,
    }
}
</script>